import React from "react";

import {createRoot} from "react-dom/client";
import AddressFinderField from "../apps/utils/AddressFinderField";
import isAuSite from "./isAuSite";

export default () => {

    const input = document.getElementById('RegisterForm_RegisterForm_AddressLine1');
    if (input) {

      window.addEventListener('ADDRESS_SELECTED', (e) => {
        const address = e.data;
        document.getElementById('RegisterForm_RegisterForm_AddressLine1').value = `${address.unit_type ? address.unit_type : ''} ${address.unit_value ? address.unit_value : ''}${address.unit_type || address.unit_value ? ',': ''} ${address.street_number}${address.street_alpha ? address.street_alpha : ''} ${address.street} ${address.street_type}`;
        document.getElementById('RegisterForm_RegisterForm_AddressLine2').value = address.suburb;
        document.getElementById('RegisterForm_RegisterForm_City').value = address.city;
        document.getElementById('RegisterForm_RegisterForm_PostCode').value = address.postcode;
        document.getElementById('RegisterForm_RegisterForm_Country').value = address.country;
      });

      input.style.display = 'none';
      const parent = input.parentElement;
      const div = document.createElement('div');
      parent.append(div);


      const root = createRoot(div);
      root.render(<AddressFinderField
        dom={input}
        isAu={isAuSite()}
      />);

    }
}
